import { render, staticRenderFns } from "./DistributeSpecialContributionAmountLinkedGoalsWealth.vue?vue&type=template&id=b12e7b98&scoped=true&"
import script from "./DistributeSpecialContributionAmountLinkedGoalsWealth.vue?vue&type=script&lang=ts&"
export * from "./DistributeSpecialContributionAmountLinkedGoalsWealth.vue?vue&type=script&lang=ts&"
import style0 from "./DistributeSpecialContributionAmountLinkedGoalsWealth.vue?vue&type=style&index=0&id=b12e7b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12e7b98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCheckbox,VCol,VDialog,VIcon,VImg,VRow,VTextField})
